import Footer from "./Components/Footer";
import Header from "./Components/Header";
import AboutUs from './Components/AboutUs';
import Services from './Components/Services';
import Gallery from './Components/Gallery';
import "./styles/tailwind.css";
import HeroSection from "./Components/HeroSection";
import ApplicationForm from "./Components/ApplicationForm";
import ConsultationBooking from "./Components/ConsultationBooking";
import EmbeddedApplicationForm from "./Components/EmbeddedApplicationForm";
function App() {
    const params = new URLSearchParams(window.location.search);
    const page = params.get("page");

    if (page === "service") {
        return <EmbeddedApplicationForm formType={params.get("form")} />;
    }

    if (
        window.location.pathname === "/consultation" ||
        window.location.hash === "#/consultation" ||
        page === "consultation"
    ) {
        return <ConsultationBooking />;
    }

    if (
        window.location.pathname === "/application" ||
        window.location.hash === "#/application" ||
        page === "application"
    ) {
        return <ApplicationForm />;
    }

    return (
        <div>
            <Header></Header>
            <main>
                <HeroSection />
                <AboutUs />
                <Services />
                <Gallery />
            </main>
            <Footer></Footer>
        </div>
    );
}

export default App;
